import { render, staticRenderFns } from "./PopupReformationResult.vue?vue&type=template&id=2c1d2d4b&scoped=true"
import script from "./PopupReformationResult.vue?vue&type=script&lang=js"
export * from "./PopupReformationResult.vue?vue&type=script&lang=js"
import style0 from "./PopupReformationResult.vue?vue&type=style&index=0&id=2c1d2d4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d2d4b",
  null
  
)

export default component.exports